// extracted by mini-css-extract-plugin
export default {"emailPreview":"EmailPreview_emailPreview__-Q1wc","body":"EmailPreview_body__SkhcC","recipient":"EmailPreview_recipient__goAPY"};